// js
import React from 'react';
import PropTypes from 'prop-types';
import ProgressCircle from '../../components/common/ProgressCircle';
import { FormattedNumber } from 'react-intl';


function OverlapTotalDataIndexed({ areaTitle, percentTotal, totalData, ciscoDataPerDay, nonCiscoDataPerDay, ciscoDataIndexed, nonCiscoDataIndexed, ciscoPercentIndexed, nonCiscoPercentIndexed }) {
  return (
    <div className='analytics__overlap-total-data-indexed'>
      <h6 className='analytics__overlap-title'>{areaTitle}</h6>
      <div className='totals-chart'>
        <ProgressCircle className='totals-circle' percent={percentTotal}>
          <div className='totals-chart-content'>
            <h1><FormattedNumber value={percentTotal} style='percent' /></h1>
            <h8>Total Data Indexed</h8>
            <h5><FormattedNumber value={totalData} maximumFractionDigits={1} /> GB/day</h5>
            <div className='totals-chart-content__cisco-split'>
              <div><FormattedNumber value={nonCiscoDataPerDay} maximumFractionDigits={1} /> GB/day Non Cisco</div>
              <div><FormattedNumber value={ciscoDataPerDay} maximumFractionDigits={1} /> GB/day Cisco Data</div>
            </div>
          </div>
        </ProgressCircle>
      </div>
      <div className='totals-chart-content__cisco-indexed'>
        <div><FormattedNumber value={nonCiscoDataIndexed} maximumFractionDigits={1} /> GB/day indexed Non Cisco ({nonCiscoPercentIndexed}%)</div>
        <div><FormattedNumber value={ciscoDataIndexed} maximumFractionDigits={1} /> GB/day indexed Cisco ({ciscoPercentIndexed}%)</div>
      </div>
    </div>
  );
}

OverlapTotalDataIndexed.defaultProps = {
  ciscoDataPerDay: 0,
  nonCiscoDataPerDay: 0,
  ciscoDataIndexed: 0,
  nonCiscoDataIndexed: 0,
  ciscoPercentIndexed: 0,
  nonCiscoPercentIndexed: 0
};

OverlapTotalDataIndexed.propTypes = {
  areaTitle: PropTypes.string.isRequired,
  percentTotal: PropTypes.number.isRequired,
  totalData: PropTypes.number.isRequired,
  ciscoDataPerDay: PropTypes.number,
  nonCiscoDataPerDay: PropTypes.number,
  ciscoDataIndexed: PropTypes.number,
  nonCiscoDataIndexed: PropTypes.number,
  ciscoPercentIndexed: PropTypes.number,
  nonCiscoPercentIndexed: PropTypes.number
};

export default OverlapTotalDataIndexed;



// WEBPACK FOOTER //
// ./src/components/analytics/OverlapTotalDataIndexed.js